var _ = require('lodash')

export default {
  collection(data) {
    if (data && data.length > 0) {
      data = data.map((item, key) => {
        item.id = _.get(item, 'id', '')
        item.image = _.get(item, 'assets.path', '')
        item.name = _.get(item, 'name', '')
        item.categoryName = _.get(item, 'categories[0].name', '')
        item.categoryDescription= _.get(item, 'categories[0].description', '')
        item.brandImage = _.get(item, 'brand.asset.path', '')
        item.brandName = _.get(item, 'brand.name', '')
        item.fuelTag = _.get(item, 'label.fuel_label', '')
        item.wetTag = _.get(item, 'label.wet_grip_label', '')
        item.noiseTag = _.get(item, 'label.noise_label', '')
        item.seasonTag = _.get(item, 'categories[0].season.id', '').toString()
        item.salePrice = _.get(item, 'sale_price', 0)
        item.listPrice = _.get(item, 'list_price', 0)
        item.discountPrice = _.get(item, 'discount_price', 0)
        item.four_product_price= _.get(item, 'four_product_price', 0)
        item.slug = _.get(item, 'slug', '')
        item.barcode = _.get(item, 'barcode', '')
        item.quantity = _.get(item, 'quantity', '')
        item.dealerName = _.get(item, 'branch.name', '')
        item.dealerSlug = _.get(item, 'branch.slug', '')
        item.dealerLocation = _.get(item, 'branch.district.name', '') + '/' + _.get(item, 'branch.city.name', '')
        item.score = _.get(item, 'product_score', 0)
        item.feedbackCount = _.get(item, 'feedback_count', 0)
        item.brandSlug = _.get(item, 'brand.slug', '')
        item.check_service_discounts = _.get(item, 'check_service_discounts', false)
        item.best_seller=_.get(item, 'best_seller', true)
        return item
      })
    }

    return data
  },
  get(data) {
    return {
      id: _.get(data, 'id', ''),
      image: _.get(data, 'assets.path', ''),
      name: _.get(data, 'name', ''),
      categoryName: _.get(data, 'categories[0].name', ''),
      categoryDescription: _.get(data, 'categories[0].description', ''),
      brandImage: _.get(data, 'brand.asset.path', ''),
      brandName: _.get(data, 'brand.name', ''),
      fuelTag: _.get(data, 'label.fuel_label', ''),
      wetTag: _.get(data, 'label.wet_grip_label', ''),
      noiseTag: _.get(data, 'label.noise_label', ''),
      seasonTag: _.get(data, 'categories[0].season.id', '').toString(),
      price: _.get(data, 'price', 0),
      salePrice: _.get(data, 'sale_price', 0),
      discountPrice: _.get(data, 'discount_price', 0),
      four_product_price: _.get(data, 'four_product_price', 0),
      barcode: _.get(data, 'barcode', ''),
      listPrice: _.get(data, 'list_price', 0),
      quantity: _.get(data, 'quantity', ''),
      slug: _.get(data, 'slug', ''),
      dealerName: _.get(data, 'branch.name', ''),
      dealerSlug: _.get(data, 'branch.slug', ''),
      dealerLocation: _.get(data, 'branch.district.name', '') + '/' + _.get(data, 'branch.city.name', ''),
      score: _.get(data, 'product_score', 0),
      feedbackCount: _.get(data, 'feedback_count', 0),
      brandSlug: _.get(data, 'brand.slug', ''),
      check_service_discounts: _.get(data, 'check_service_discounts', false),
      best_seller: _.get(data, 'best_seller', true)
    }
  },
  getById(data) {
    return {
      id: data.id,
      barcode: _.get(data, 'barcode', ''),
      name: _.get(data, 'name', ''),
      branchId: _.get(data, 'branch.id', 0),
      branchName: _.get(data, 'branch.name', ''),
      branchSlug: _.get(data, 'branch.slug', ''),
      branchScore: _.get(data, 'branch.score', 0),
      branchAddress: _.get(data, 'branch.address', ''),
      brandName: _.get(data, 'brand.name', ''),
      brandSlug: _.get(data, 'brand.slug', ''),
      branches: _.get(data, 'branches', []),
      slug: _.get(data, 'slug'),
      salePrice: _.get(data, 'sale_price', ''),
      listPrice: _.get(data, 'list_price', ''),
      discountPrice: _.get(data, 'discount_price', ''),
      price: _.get(data, 'price', ''),
      four_product_price: _.get(data, 'four_product_price', ''),
      branchServices: _.get(data, 'branchServices', {}),
      image: _.get(data, 'asset.path', ''),
      score: _.get(data, 'product_score' , 0),
      quantity: _.get(data, 'quantity', 0),
      height: _.get(data, 'height', 0),
      width: _.get(data, 'width', 0),
      radius: _.get(data, 'radius', 0),
      radialStructure: _.get(data, 'radial_structure', 0),
      speed: _.get(data, 'speed', 0),
      sku: _.get(data, 'sku', '',),
      runFlat: _.get(data, 'run_flat', false),
      categoryName: _.get(data, 'categories[0].title',''),
      categoryDescription: _.get(data, 'categories[0].description', ''),
      seasonTag: _.get(data, 'categories[0].season.id',''),
      loadIndex: _.get(data, 'load_index', ''),
      fuelTag: _.get(data, 'label.fuel_label', ''),
      wetTag: _.get(data, 'label.wet_grip_label', ''),
      noiseTag: _.get(data, 'label.noise_label', ''),
      description: _.get(data, 'description', ''),
      branch: _.get(data, 'branch', {}),
      brand: _.get(data, 'brand', {}),
      similarProducts: _.get(data, 'similarProducts', []),
      campaign: _.get(data, 'campaign', {}),
      model: _.get(data, 'model'),
      promotionProducts: _.get(data, 'promotionProducts', []),
      attachments: _.get(data, 'attachments', []),
      categoryFeedbacks: _.get(data, 'categoryFeedbacks', []),
      tireCategoryFeedbacks: _.get(data, 'tireCategoryFeedbacks', []),
      isFavorite: _.get(data, 'product_in_favorite', false),
      feedbackCount: _.get(data, 'feedback_count', 0),
      priceId: _.get(data, 'price_id', null),
      metaTitle: _.get(data, 'meta_title', ''),
      metaDescription: _.get(data, 'meta_description', ''),
      metaKeywords: _.get(data, 'meta_keywords', ''),
      showPrice: _.get(data, 'showPrice', true),
      check_service_discounts: _.get(data, 'check_service_discounts', false),
      campaign_service_discounts: _.get(data, 'campaign_service_discounts', false),
      best_seller: _.get(data, 'best_seller', true),
    }
  }
}

function floor(num){
  let f = Math.floor(num);
  if(num-f < 0.5){
    return f;
  }
  return f+0.5;
}
